<template>
    <v-app>
        <app-top-bar :menu="menu" :color="'linear-gradient(135deg, #8E0E4E 0%, #E0115F 100%)'" :moduleName="'MULTI-ACCESS MODULE'"/>
        <v-main>
        <router-view/>
        </v-main>
  </v-app>
</template>

<script>
import AppTopBar from '../components/AppTopAndSideBar.vue';

export default {
  components: { AppTopBar},
    name: 'MultiAccessLayout',
    data: () => ({
        menu: [
            { text: 'All Modules', icon: 'mdi-view-dashboard', routerName: 'ModuleSelector' },
        ],
    }),
};
</script>